import background from './background';
import iconColor from './icon-color';

export default {
  background,
  iconColor,
};
